import { Link } from "expo-router";
import { Chips } from "@ptsd/uikit";
import { View } from "tamagui";

import { api } from "~/utils/api";
import { usePathIncludes } from "~/hooks";

export const ResearchNavbar = () => {
  const [list] = api.research.types.useSuspenseQuery(undefined, {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
  const { match } = usePathIncludes();

  return (
    <View flexDirection="row" gap={"$1"} flexWrap="wrap">
      {list.map(({ value, name }) => (
        <Link key={value} href={`/research/${value}`}>
          <Chips.Chip
            cursor="pointer"
            selected={match(value)}
            backgroundColor="#0B564C"
          >
            {name}
          </Chips.Chip>
        </Link>
      ))}
    </View>
  );
};
